/**
 * Policy configuration for the 2026 policy rollout.
 * 
 * When a policy is revised:
 * 1. Upload the new PDF to the assets bucket
 * 2. Update the sha256 hash here
 * 3. All affected users will see the acceptance interstitial on next login
 * 
 * GATE CONTROL:
 * - POLICY_GATE_ENABLED_AFTER controls when the gate activates.
 * - Before this date/time, all users pass through without being prompted.
 * - On or after this date/time, the gate enforces policy acceptance.
 * - Set to null to enforce immediately.
 * - Uses ISO 8601 format in Eastern Time.
 */

export const POLICY_GATE_ENABLED_AFTER: string | null = "2026-03-23T06:00:00-04:00"; // Monday March 23, 6am ET

export const POLICY_CONFIG: Record<string, {
  policyType: string;
  policyVersion: string;
  title: string;
  effectiveDate: string;
  downloadPath: string;
}> = {
  isProvider: {
    policyType: "provider_2026",
    policyVersion: "b2b1bb805c4f9a7214674b40ccd92a66e67e09b90d2f6c45b88fc1cf996f8722",
    title: "2026 Provider & Preferred Provider Policy",
    effectiveDate: "March 23, 2026",
    downloadPath: "policies/provider/Provider-Terms-2026-v1.pdf",
  },
  isClient: {
    policyType: "client_2026",
    policyVersion: "ed630038196bc29f07c66865942d21b703b0ef3d618ef794a5a348974e8bb1bb",
    title: "2026 Client Policy & Procedure Update",
    effectiveDate: "March 23, 2026",
    downloadPath: "policies/client/Client-Terms-2026-v1.pdf",
  },
  isClientAdmin: {
    policyType: "client_2026",
    policyVersion: "ed630038196bc29f07c66865942d21b703b0ef3d618ef794a5a348974e8bb1bb",
    title: "2026 Client Policy & Procedure Update",
    effectiveDate: "March 23, 2026",
    downloadPath: "policies/client/Client-Terms-2026-v1.pdf",
  },
};

/**
 * Access levels that require policy acceptance.
 * isSuper and isCompany are internal users — they skip.
 */
export const POLICY_REQUIRED_ACCESS_LEVELS = ["isProvider", "isClient", "isClientAdmin"];
